import React, { useState, useEffect } from "react";
import { Row, Modal, Form } from "react-bootstrap";
import { getFromLS } from "../../../utils/storage";
import { FormContext } from "../../reusable_components/input_fields/FormContext";
import Element from "../../reusable_components/input_fields/Input";
import { v4 as uuidv4 } from "uuid";
import "react-toastify/dist/ReactToastify.css";
import TemplateDownload from "../../../Reusables/components/TemplateDownload/TemplateDownload";
import alertModalStyles from "../../../Reusables/components/AlertModal/AlertModal.module.css";
import styles from "./UploadSpreadsheetModal.module.css";

import { handleChange, handleClose } from "./UploadSpreadsheetModal.utils";
import { populateTemplate } from "./UploadSpreadsheetModal.service";

import {
  EngagementLetterTemplate,
  UploadSpreadsheetModalProps,
} from "./UploadSpreadsheetModal.types";
import SelectInput from "../../../Reusables/components/SelectInput/SelectInput";
import { FieldProps } from "../../reusable_components/input_fields/Input";

const UploadSpreadsheetModal: React.FC<UploadSpreadsheetModalProps> = ({
  show,
  onHide,
  setfileuploading,
  refresh,
  engagementlettertemplates,
}) => {
  const token = getFromLS("token");

  const [elements, setElements] = useState<FieldProps[]>([
    {
      id: uuidv4(),
      label: null,
      mandatory: false,
      approval: false,
      disabled: false,
      placeholder: "Upload Spreadsheet File",
      type: "file",
      example: null,
      pivot: true,
      pivotreverse: false,
      value: "",
      width: 12,
      fileTypes: ".xlsx,.csv,.xls"
    },
  ]);

  const [engagementLetterTemplateOptions, setEngagementLetterTemplateOptions] =
    useState<EngagementLetterTemplate[]>([]);
  const [engagementLetterTemplate, setEngagementLetterTemplate] =
    useState<EngagementLetterTemplate>({ id: "", label: "", value: "", bulkUpload: "N" });

  useEffect(() => {
    if (elements[0]?.value !== "") {
      populateTemplate(
        elements[0].value,
        engagementLetterTemplate.value,
        token,
        refresh,
        onHide,
        setfileuploading
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elements]);

  useEffect(() => {
    setEngagementLetterTemplateOptions(engagementlettertemplates.filter(f => f.bulkUpload === "Y"));
  }, [engagementlettertemplates]);

  return (
    <Modal
      show={show}
      onHide={() => handleClose(setfileuploading, onHide)}
      size="lg"
      centered
      keyboard={false}
      dialogClassName={alertModalStyles.dialog}
      contentClassName={alertModalStyles.content}
      backdropClassName={alertModalStyles.backdrop}
      aria-labelledby="upload-spreadsheet-modal"
    >
      <Modal.Header closeButton className={alertModalStyles.header}>
        <Modal.Title id="upload-spreadsheet-modal" className={alertModalStyles.title}>
          Bulk Engagement Letter Upload
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={alertModalStyles.body}>
        <Row>
          <SelectInput
              field={{
                id: "selectedField",
                type: "select",
                label: "Select engagement letter template",
                value: engagementLetterTemplate.value,
                textStyle: { fontSize: 11 },
                options: engagementLetterTemplateOptions,
                validation: [
                  { type: "required", message: "Required!" },
                ],
                show: true,
                width: 100
              }}
              handleChange={(fieldId: any, val: any) => {
                if (val) setEngagementLetterTemplate(val);
              }}
              handleBlur={() => {}}
              handleSelect={() => {}}
            />
        </Row>

        <div className={styles.templateDownload}>
          <TemplateDownload
            title={"Spreadsheet Template (.xlsx)"}
            endpoint="/engagement-letter/template_excel/"
            params={{
              TemplateId: engagementLetterTemplate.value,
              TemplateName: engagementLetterTemplate.label,
            }}
            extension={"xlsx"}
            filename={engagementLetterTemplate.label + "_Bulk_Upload"}
            disabled={!engagementLetterTemplate?.value}
          />
        </div>

        <FormContext.Provider
          value={{
            handleChange: (field_id, event) =>
              handleChange(elements, setElements, field_id, event),
          }}
        >
          <Form>
            <Row>
              <label className={`${alertModalStyles.message} ${styles.spreadsheetLabel}`}>Upload Spreadsheet File</label>
              {elements.map((field, i) => (
                <Element key={i} field={field} md={12} />
              ))}
              <div className={styles.rowLimitWarning}>
                <span className={styles.asterisk}>*</span>
                Maximum allowed row count for the bulk spreadsheet is <strong>200</strong>.
              </div>
            </Row>
          </Form>
        </FormContext.Provider>
      </Modal.Body>
    </Modal>
  );
};

export default UploadSpreadsheetModal;
